import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import { useContext } from 'react';
import { GlobalContext } from '../../../../App';
import { login } from '../../../../database/queries/queryConnection/connectedQueries';
import { useNavigate } from 'react-router-dom';
import theme from '../../../template/theme';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        MBE
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function SignInSide() {
  const [errors, setErrors] = React.useState({ email: '', password: '' });
  const [remember, setRemember] = React.useState(false); // For the checkbox state
  const { token, setToken, setUserId, setUserName, setPermission } = useContext(GlobalContext);

  const navigate = useNavigate();

  React.useEffect(() => {
    // Load saved email from localStorage if "Remember me" was checked
    const savedEmail = localStorage.getItem('rememberedEmail');
    if (savedEmail) {
      document.getElementById('email').value = savedEmail;
      setRemember(true);
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);
    const email = data.get('email');
    const password = data.get('password');

    if (!email || !password) {
      setErrors({
        email: !email ? 'שדה חובה' : '',
        password: !password ? 'שדה חובה' : ''
      });
      return;
    }

    if (remember) {
      // Save email to localStorage
      localStorage.setItem('rememberedEmail', email);
    } else {
      // Remove email from localStorage if "Remember me" is unchecked
      localStorage.removeItem('rememberedEmail');
    }

    const usernameLogin = email;
    const passwordLogin = password;

    let ok = await login({ usernameLogin, passwordLogin }, { setUserId, setUserName, token, setToken, setPermission });
    if (ok) {
      navigate('/');
    }
  };

  return (
    <Grid container component="main" sx={{ height: '100vh', border: '1px solid red' }}>
      <CssBaseline />
      <Grid
        item
        zIndex={1}
        xs={12}
        sm={9}
        md={4}
        component={Paper}
        elevation={9}
        square
        sx={{ height: '100%', padding: 0, backgroundColor: '#fff' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            padding: 10, // Remove any default padding or margin
            pt: 30,
            boxSizing: 'border-box' // Make sure padding doesn't affect total size
          }}>
          <Box sx={{ width: '80%', textAlign: 'center', alignItems: 'center' }}>
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main', mx: 'auto' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              כניסה למערכת
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField margin="normal" required fullWidth id="email" label="Email Address" name="email" autoComplete="email" autoFocus error={Boolean(errors.email)} helperText={errors.email} />
              <TextField margin="normal" required fullWidth name="password" label="Password" type="password" id="password" autoComplete="current-password" error={Boolean(errors.password)} helperText={errors.password} />
              <FormControlLabel control={<Checkbox value="remember" color="primary" />} label="Remember me" />
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                כניסה
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                    שכחת סיסמה?
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box sx={{ mt: 'auto', mb: 2, textAlign: 'center', width: '100%' }}>
            <Copyright />
            <Typography variant="caption" display="block">
              version 0.1.4
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        zIndex={0}
        xs={false}
        sm={3}
        md={8}
        sx={{
          backgroundColor: (t) => (t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900]),
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}>
        <Box
          component="img"
          sx={{
            height: 400,
            width: 400,
            objectFit: 'cover'
          }}
          alt="image"
          src="/logoSignIn.png"
        />
        <ThemeProvider theme={theme}>
          <Typography component="h2" style={theme?.customTypography?.typographySignIn} variant="h1" align="center" sx={{ mt: 2, width: '80%' }}>
            ארגון קהילות יהודי צפון אפריקה בירושלים
          </Typography>
        </ThemeProvider>
      </Grid>
    </Grid>
  );
}
